var _path;
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.999,13.45 L2.9996,20.096 C2.9996,20.595 3.4056,21 3.9046,21 L20.0956,21 C20.5946,21 20.9996,20.595 20.9996,20.096 L20.999,13.45 L22.999,13.45 L22.9996,20.096 C22.9996,21.697 21.6976,23 20.0956,23 L3.9046,23 C2.3026,23 0.9996,21.697 0.9996,20.096 L0.999,13.45 L2.999,13.45 Z M13.0006581,1.99984899 L13.0013652,13.0540493 L17.3550217,8.70039285 L18.7692353,10.1146064 L12.0015163,16.8823254 L5.23379726,10.1146064 L6.64801082,8.70039285 L11.0016673,13.0540493 L11.0009602,1.99984899 L13.0006581,1.99984899 Z"
  }));
};
export default SvgDownload;